import dayjs from 'dayjs'

import { isEmptyArray } from '@app/utils'
import { getTodayDate } from '@app/utils/date'

import { dateFormat } from '@app/constants'

import type { PricingConfigData } from '@app/api/routes/pricing/types'
import type { TransferSettingsFormData } from '@app/drawers/TransferSettingsDrawer/types'

const nowDateTimes = [getTodayDate()]

const DEFAULT_ADAPT_DATA: TransferSettingsFormData = {
  exportAbnormalResults: false,
  outdatedThresholdInDays: null,
  notificationsTimes: nowDateTimes
}

export const adaptPricingConfigFormData = (response?: PricingConfigData): TransferSettingsFormData => {
  if (!response) return DEFAULT_ADAPT_DATA

  const initialDates = response.notificationsTimes?.map(time => dayjs(time, dateFormat.HH_mm))

  return {
    exportAbnormalResults: response.exportAbnormalResults,
    outdatedThresholdInDays: response.outdatedThresholdInDays,
    notificationsTimes: !isEmptyArray(initialDates) ? initialDates : nowDateTimes
  }
}
